import Reveal from "@/components/Reveal";

const FRAMES = [
  {
    img: "/images/engine-yellow.webp",
    alt: "Engine bay with yellow-accented performance components",
    caption: "In the bay",
    className: "lg:col-span-7",
    imgH: "h-[46vh] sm:h-[60vh]",
  },
  {
    img: "/images/engine-bay-2.webp",
    alt: "Detailed engine bay with parts and a yellow coolant reservoir",
    caption: "Detail work",
    className: "lg:col-span-5",
    imgH: "h-[46vh] sm:h-[60vh]",
  },
];

export default function Gallery() {
  return (
    <section id="work" className="bg-ink py-24 sm:py-32">
      <div className="mx-auto max-w-[1600px] px-5 sm:px-8">
        <Reveal>
          <p className="mb-6 flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.3em] text-bone/60 sm:text-sm">
            <span className="h-px w-10 bg-steel" />
            The Work
          </p>
          <h2 className="max-w-5xl font-display text-5xl font-black uppercase leading-[0.95] tracking-[0.02em] text-bone sm:text-7xl lg:text-8xl">
            Real wrench time. <span className="text-outline">Real results.</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-5 sm:mt-20 lg:grid-cols-12">
          {FRAMES.map((f, i) => (
            <Reveal key={f.img} delay={i * 0.12} className={f.className}>
              <figure
                data-testid={`work-frame-${i + 1}`}
                className="group relative overflow-hidden border border-bone/10"
              >
                <img
                  src={f.img}
                  alt={f.alt}
                  className={`w-full object-cover grayscale-[35%] transition-all duration-500 group-hover:scale-[1.03] group-hover:grayscale-0 ${f.imgH}`}
                />
                <div className="pointer-events-none absolute inset-0 bg-ink/20" />
                <figcaption className="absolute bottom-0 left-0 flex items-center gap-3 bg-ink/85 px-6 py-4 font-display text-lg font-semibold uppercase tracking-wide text-bone sm:text-xl">
                  <span className="h-2 w-2 rotate-45 bg-steel" />
                  {f.caption}
                </figcaption>
              </figure>
            </Reveal>
          ))}

          <Reveal delay={0.15} className="lg:col-span-12">
            <blockquote className="border border-bone/10 bg-charcoal px-6 py-12 text-center sm:px-10 sm:py-16">
              <p className="mx-auto max-w-4xl font-display text-4xl font-black uppercase leading-[0.95] tracking-[0.02em] text-bone sm:text-6xl lg:text-7xl">
                &ldquo;Anything you want,{" "}
                <span className="text-outline">we can do it!</span>&rdquo;
              </p>
              <cite className="mt-6 block text-xs font-semibold uppercase not-italic tracking-[0.3em] text-bone/60">
                — Dreamworlds Garage
              </cite>
            </blockquote>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
